import styled from "styled-components";
import { useState, useEffect, useContext } from "react";
import { OrgTreeContext } from "../../../Contexts/OrgTreeContext";
import { InputSwitch } from "primereact/inputswitch";
import UserEdit from "../UserEdit/UserEdit";
import { DialogWindowContext } from "../../../Contexts/DialogueWindowContext";
import { deleteRoleFromUser } from "../../../Helpers/UsersCleanFunctions";
import { updateOrgTreeWithNewUserRoles } from "../../../Helpers/OrgTreeFunctions";
import { uploadUser, saveOrgTree } from "../../../Firebase";

const TeamMemberRowWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 80px 80px 80px;
  padding: 10px 0;
  justify-items: center;
  align-items: center;
  border-bottom: 1px solid var(--accent-color-light);
  text-align: center;

  @media (max-width: 550px) {
    grid-template-columns: 1fr 1fr 50px;
    padding: 7px 0px;
  }
`;

const UserEditWindow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export default function TeamMemberRow({ teamMember, selectedTeam }: Props) {
  const orgTree = useContext(OrgTreeContext);
  const [checked, setChecked] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const DialogWindow = useContext(DialogWindowContext);

  useEffect(() => {
    if (teamMember && selectedTeam) {
      if (
        teamMember.PCRoles.some(
          (role) =>
            (role.role === "oversight" &&
              role.teamId === selectedTeam.teamId) ||
            (role.role === "admin" && role.teamId === selectedTeam.teamId)
        )
      ) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [teamMember, selectedTeam]);

  const onDeleteUser = () => {
    if(!orgTree)return;
    let newTeamMember = teamMember;
    const rolesToDelete = teamMember.PCRoles.filter(
      (role) => role.teamId === selectedTeam.teamId
    );
    rolesToDelete.forEach((role) => {
      newTeamMember = deleteRoleFromUser(teamMember, role);
    });
    uploadUser(newTeamMember);
    const newOrgTree = updateOrgTreeWithNewUserRoles(orgTree, teamMember);
    saveOrgTree(newOrgTree);
  };

  const onLeaderSwitchChange = () => {
    if (!orgTree) return;
    if (checked) {
      let newTeamMember: UserData = JSON.parse(JSON.stringify(teamMember));
      const rolesToDelete = teamMember.PCRoles.filter(
        (role) =>
          (role.role === "oversight" &&
            role.teamId === selectedTeam.teamId &&
            selectedTeam.teamType !== "global") ||
          (role.role === "admin" &&
            role.teamId === selectedTeam.teamId &&
            selectedTeam.teamType === "global")
      );
      rolesToDelete.forEach((role) => {
        newTeamMember = deleteRoleFromUser(teamMember, role);
      });
      uploadUser(newTeamMember);

      const newOrgTree = updateOrgTreeWithNewUserRoles(orgTree, teamMember);
      saveOrgTree(newOrgTree);
    } else {
      let newTeamMember: UserData = JSON.parse(JSON.stringify(teamMember));
      let leaderRole: RoleType;
      if (selectedTeam.teamType === "global") {
        leaderRole = "admin";
      } else {
        leaderRole = "oversight";
      }
      newTeamMember.PCRoles.push({
        role: leaderRole,
        teamId: selectedTeam.teamId,
      });
      uploadUser(newTeamMember);
      const newOrgTree = updateOrgTreeWithNewUserRoles(orgTree, teamMember);
      saveOrgTree(newOrgTree);
    }
  };

  const showEditWindowHandler = () => {
    DialogWindow.setDialogProps((prevProps) => ({
      ...prevProps,
      showEditWindow: true,
      header: `${teamMember.firstName} ${teamMember.lastName}`,
      children: <UserEdit teamMember={teamMember} selectedTeam={selectedTeam} />,
    }));
  };

  return (
    <TeamMemberRowWrapper key={`row-id-${teamMember.userId}`}>
      <p key={`firstName-id-${teamMember.userId}`}>{teamMember.firstName}</p>
      <p key={`lastName-id-${teamMember.userId}`}>{teamMember.lastName}</p>
      {windowWidth > 550 && (
        <>
          <InputSwitch
            checked={checked}
            onChange={onLeaderSwitchChange}
            key={`leader-switch-id-${teamMember.userId}`}
          />
          <i
            key={`remove-cross-id-${teamMember.userId}`}
            className="pi pi-times"
            style={{ color: "red" }}
            onClick={onDeleteUser}
          ></i>
        </>
      )}
      <i
        key={`edit-pencil-id-${teamMember.userId}`}
        className="pi pi-pencil"
        style={{ color: "green" }}
        onClick={() => showEditWindowHandler()}
      ></i>
    </TeamMemberRowWrapper>
  );
}

interface Props {
  teamMember: UserData;
  selectedTeam: OrgTreeItem;
}
